"use client";

import { Switch as BaseSwitch } from "@base-ui/react/switch";
import * as React from "react";

import { cn } from "@/lib/utils";

type SwitchProps = BaseSwitch.Root.Props & {
  size?: "default" | "sm";
};

const Switch = React.forwardRef<React.ComponentRef<"span">, SwitchProps>(
  ({ className, size = "default", ...props }, ref) => (
    <BaseSwitch.Root
      className={cn(
        "peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-checked:bg-primary data-unchecked:bg-input",
        size === "sm" ? "h-5 w-9" : "h-6 w-11",
        className,
      )}
      {...props}
      ref={ref}
    >
      <BaseSwitch.Thumb
        className={cn(
          "pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform",
          size === "sm" ? "h-4 w-4 data-checked:translate-x-4" : "h-5 w-5 data-checked:translate-x-5",
          "data-unchecked:translate-x-0",
        )}
      />
    </BaseSwitch.Root>
  ),
);
Switch.displayName = "Switch";

export { Switch };
